var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ml-auto mr-0" }, [
      !_vm.globalViewOption("UpdateInvoice")
        ? _c(
            "button",
            {
              staticClass: "btn btn-h btn-primary px-3 mb-4",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.view_invoice = !_vm.view_invoice
                },
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.view_invoice ? "Editar" : "Ver") + " factura"
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.view_invoice
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [_c("billing", { attrs: { print: false } })],
            1
          ),
        ])
      : _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("generate", {
                attrs: { prevent: true },
                on: {
                  end: function ($event) {
                    _vm.view_invoice = true
                  },
                },
              }),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }